var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__header"},[_c('SfHeading',{staticClass:"moomin-heading--no-underline moomin-heading--left",attrs:{"title":_vm.product.title,"description":_vm.product.subtitle,"level":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }